import { Environment } from 'uns-common';

export const ENVIRONMENT =
	(process.env.REACT_APP_ENVIRONMENT as Environment) ?? Environment.development;
export const IS_DEVELOPMENT = ENVIRONMENT === Environment.development;
